import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import InvestmentOpportunityService from "./InvestmentOpportunityService";


export const getInvestmentOpportunitys = createAsyncThunk("InvestmentOpportunity/get-InvestmentOpportunitys", async (thunkAPI) => {
  try {
    return await InvestmentOpportunityService.getInvestmentOpportunitys();
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
}); 
export const createInvestmentOpportunitys = createAsyncThunk(
  "InvestmentOpportunity/create-InvestmentOpportunitys",
  async (InvestmentOpportunityData, thunkAPI) => {
    try {
      return await InvestmentOpportunityService.createInvestmentOpportunitys(InvestmentOpportunityData);
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const getInvestmentOpportunity = createAsyncThunk(
  "InvestmentOpportunity/get-InvestmentOpportunity",
  async (thunkAPI) => {
    try {
      return await InvestmentOpportunityService.getInvestmentOpportunity();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const updateInvestmentOpportunity = createAsyncThunk(
  "InvestmentOpportunity/update-InvestmentOpportunity",
  async (brand, thunkAPI) => {
    try {
      return await InvestmentOpportunityService.updateInvestmentOpportunity(brand);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const deleteAInvestmentOpportunity = createAsyncThunk(
  "InvestmentOpportunity/delete-InvestmentOpportunity",
  async (id, thunkAPI) => {
    try {
      return await InvestmentOpportunityService.deleteInvestmentOpportunity(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const resetState = createAction("Reset_all");

const initialState = {
  InvestmentOpportunitys: [],
  isError: false,
  isLoading: false,
  isSuccess: false,
  message: "",
};
export const InvestmentOpportunitySlice = createSlice({
  name: "InvestmentOpportunity",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getInvestmentOpportunitys.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getInvestmentOpportunitys.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.InvestmentOpportunitys = action.payload.data;
      })
      .addCase(getInvestmentOpportunitys.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(createInvestmentOpportunitys.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createInvestmentOpportunitys.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.createdInvestmentOpportunity = action.payload;
      })
      .addCase(createInvestmentOpportunitys.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.payload;
      })
      .addCase(getInvestmentOpportunity.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getInvestmentOpportunity.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.opportunityName= action.payload.data.opportunityName;
        state.opportunityDetails= action.payload.data.opportunityDetails; 
      })
      .addCase(getInvestmentOpportunity.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(updateInvestmentOpportunity.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateInvestmentOpportunity.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.updatedInvestmentOpportunity = action.payload;
      })
      .addCase(updateInvestmentOpportunity.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(deleteAInvestmentOpportunity.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteAInvestmentOpportunity.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.deletedInvestmentOpportunity = action.payload;
      })
      .addCase(deleteAInvestmentOpportunity.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(resetState, () => initialState);
  },
});
export default InvestmentOpportunitySlice.reducer;
